import React, {useLayoutEffect} from 'react'
import useNavigation from '../../hooks/useNavigation'
import UserListPage from '../user/UserListPage'

interface IProps {
    className?: string
}

const MainPage: React.FC<IProps> = ({className}) => {
    const {goLogin} = useNavigation()
    const loginToken = localStorage.getItem('wiz-admin-userToken')
    const loginId = localStorage.getItem('wiz-admin-userId')

    useLayoutEffect(() => {
        if (!loginToken && !loginId) {
            goLogin()
        }
    }, [loginToken, loginId])

    return <UserListPage />
}

export default MainPage
